import { Controller } from "../vendor/stimulus.js";

export default class extends Controller {
  static values = {
    src: String,
  };

  connect() {
    this.abortController = null;
    this.inlineSvg();
  }

  disconnect() {
    this.abortPendingRequest();
  }

  inlineSvg() {
    const source = this.srcValue || this.element?.getAttribute("src");
    if (!source || typeof fetch !== "function") return;

    this.abortPendingRequest();
    this.abortController = new AbortController();

    fetch(source, { signal: this.abortController.signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`inline-svg: failed to load ${source} (${response.status})`);
        }
        return response.text();
      })
      .then((svgText) => {
        const inlineSvg = this.parseSvg(svgText);
        if (!inlineSvg) return;

        this.replaceImageWithInlineSvg(inlineSvg);
      })
      .catch((error) => {
        if (error?.name === "AbortError") return;
        console.warn("inline-svg: unable to inline SVG", error);
      });
  }

  parseSvg(svgText) {
    if (!svgText) return null;
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgText, "image/svg+xml");
    const svgElement = doc.documentElement;
    if (!svgElement || svgElement.nodeName.toLowerCase() !== "svg") {
      return null;
    }
    svgElement.setAttribute("aria-hidden", "true");
    return svgElement.cloneNode(true);
  }

  abortPendingRequest() {
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
  }

  replaceImageWithInlineSvg(svgElement) {
    if (!this.element?.parentNode) return;

    const inlineWrapper = document.createElement("div");
    inlineWrapper.classList.add("svg-inline");
    inlineWrapper.appendChild(svgElement);

    this.element.replaceWith(inlineWrapper);
  }
}
